/*
  Animazioni della homepage — GSAP core (nessun plugin).
  - Timeline d'apertura: righe del titolo mascherate, apertura della foto, filetti che si tracciano.
  - Ticker infinito che cambia verso a seconda della direzione dello scroll.
  - Manifesto: le parole si accendono una a una mentre il blocco attraversa il viewport.
  Tutto è dentro gsap.matchMedia(): con prefers-reduced-motion non si muove nulla.
*/

(function () {
  if (!window.gsap) return;

  // Ogni sezione della home include questo script: eseguo una volta sola.
  if (window.__homeMotion) return;
  window.__homeMotion = true;

  var mm = gsap.matchMedia();

  /* ---------- Apertura della pagina ---------- */

  function apertura(scope) {
    var hero = scope.querySelector('[data-home-hero]');
    if (!hero || hero.dataset.homeInit) return;
    hero.dataset.homeInit = 'true';

    var illustrazione = hero.dataset.heroStyle === 'illustrazione';
    var tl = gsap.timeline({ defaults: { ease: 'power3.out' } });

    tl.from(hero.querySelectorAll('[data-hero-line] > span'), {
      yPercent: 115,
      duration: 1.1,
      stagger: 0.09
    })
      .from(
        hero.querySelectorAll('.home__eyebrow, .hero__lede, .hero__actions'),
        { y: 20, autoAlpha: 0, duration: 0.8, stagger: 0.1 },
        0.25
      )
      .from(
        hero.querySelectorAll('.hero__meta > *'),
        { y: 24, autoAlpha: 0, duration: 0.7, stagger: 0.08 },
        0.9
      );

    if (illustrazione) {
      // Il fondale 9:16 emerge con un fade e un lento zoom d'assestamento, poi
      // respira con una deriva continua. Lo zoom lascia il margine che rende
      // possibile la deriva senza mostrare i bordi.
      var bg = hero.querySelector('[data-hero-bg]');
      var img = bg && bg.querySelector('img');
      var mobile = window.matchMedia('(max-width: 989px)').matches;

      if (bg) {
        tl.to(bg, { autoAlpha: 1, duration: 1.6, ease: 'power2.out' }, 0.2);
      }
      if (img) {
        if (mobile) {
          // Copertura piena dello schermo: deriva orizzontale. La posizione di
          // partenza della deriva è pre-impostata qui, a fondale ancora invisibile:
          // se la si impostasse all'avvio della deriva, l'immagine scatterebbe.
          gsap.set(img, { xPercent: -1 });
          tl.fromTo(
            img,
            { scale: 1.14 },
            { scale: 1.06, duration: 2.6, ease: 'power2.out' },
            0.2
          ).add(function () {
            gsap.fromTo(
              img,
              { xPercent: -1 },
              { xPercent: 1, duration: 26, ease: 'sine.inOut', yoyo: true, repeat: -1 }
            );
          }, 1.4);
        } else {
          // Pannello verticale ancorato a destra: la scala parte dal bordo destro
          // (che resta fermo e non si taglia mai) e la deriva è verticale.
          // yPercent parte già da -0.8 (fondale ancora invisibile) così l'avvio
          // della deriva a 1.4s non produce alcuno scatto.
          gsap.set(img, { transformOrigin: 'right center', yPercent: -0.8 });
          tl.fromTo(
            img,
            { scale: 1.1 },
            { scale: 1.03, duration: 2.6, ease: 'power2.out' },
            0.2
          ).add(function () {
            gsap.fromTo(
              img,
              { yPercent: -0.8 },
              { yPercent: 0.8, duration: 22, ease: 'sine.inOut', yoyo: true, repeat: -1 }
            );
          }, 1.4);
        }
      }
    } else {
      // La foto si apre dal basso come una tenda.
      tl.to(
        hero.querySelector('.hero__media'),
        { clipPath: 'inset(0% 0% 0% 0%)', duration: 1.2 },
        0.35
      ).from(hero.querySelector('.hero__caption'), { yPercent: 100, duration: 0.6 }, 1.1);
    }

    return tl;
  }

  /* ---------- Ticker infinito ---------- */

  function ticker(scope) {
    // Raccolgo le funzioni di rimozione dei listener: il context di matchMedia
    // killa le tween, ma i listener di scroll vanno tolti a mano.
    var rimuovi = [];

    scope.querySelectorAll('[data-ticker]').forEach(function (el) {
      if (el.dataset.tickerInit) return;
      var track = el.querySelector('.ticker__track');
      var gruppo = el.querySelector('.ticker__group');
      if (!track || !gruppo) return;
      el.dataset.tickerInit = 'true';

      // Duplico il gruppo: due copie identiche permettono il loop senza salti.
      track.appendChild(gruppo.cloneNode(true));

      var durata = parseFloat(el.dataset.ticker) || 26;
      var loop = gsap.to(track, {
        xPercent: -50,
        duration: durata,
        ease: 'none',
        repeat: -1
      });

      // Lo scroll all'ingiù accelera il nastro, lo scroll all'insù lo fa tornare indietro.
      var ultimo = window.scrollY;
      var reset = null;

      var onScroll = function () {
        var y = window.scrollY;
        var direzione = y > ultimo ? 1 : -1;
        ultimo = y;

        gsap.to(loop, { timeScale: direzione * 3, duration: 0.3, overwrite: true });
        clearTimeout(reset);
        reset = setTimeout(function () {
          gsap.to(loop, { timeScale: direzione, duration: 0.8, overwrite: true });
        }, 140);
      };

      window.addEventListener('scroll', onScroll, { passive: true });

      rimuovi.push(function () {
        window.removeEventListener('scroll', onScroll);
      });
    });

    return function () {
      rimuovi.forEach(function (fn) {
        fn();
      });
    };
  }

  /* ---------- Manifesto: parole che si accendono ---------- */

  function manifesto(scope) {
    var blocchi = [];
    var aTempo = [];

    scope.querySelectorAll('[data-manifesto]').forEach(function (el) {
      if (el.dataset.manifestoInit) return;
      el.dataset.manifestoInit = 'true';

      var parole = el.querySelectorAll('.manifesto__word');
      if (!parole.length) return;

      // Modalità "auto": accensione in sequenza appena il blocco è in vista.
      // Serve ai manifesti in cima alla pagina, che non hanno abbastanza corsa
      // di scroll sotto di sé perché l'effetto legato allo scroll si completi.
      if (el.dataset.manifesto === 'auto') {
        el._manifestoParole = parole;
        aTempo.push(el);
        return;
      }

      blocchi.push({
        el: el,
        parole: parole,
        set: gsap.quickSetter(parole, 'opacity')
      });
    });

    var osservatore = null;
    if (aTempo.length) {
      osservatore = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            osservatore.unobserve(entry.target);
            gsap.to(entry.target._manifestoParole, {
              opacity: 1,
              duration: 0.5,
              ease: 'power1.out',
              stagger: 0.045
            });
          });
        },
        { threshold: 0.2 }
      );
      aTempo.forEach(function (el) {
        osservatore.observe(el);
      });
    }

    if (!blocchi.length && !aTempo.length) return null;

    var pending = false;

    function aggiorna() {
      pending = false;
      var h = window.innerHeight;

      blocchi.forEach(function (b) {
        var r = b.el.getBoundingClientRect();
        // Progresso da 0 (blocco in arrivo dal basso) a 1 (blocco uscito a metà schermo).
        var progresso = gsap.utils.clamp(0, 1, gsap.utils.mapRange(h * 0.85, h * 0.25, 0, 1, r.top));
        var totale = b.parole.length;

        b.parole.forEach(function (parola, i) {
          // Ogni parola ha la sua finestra di accensione lungo il progresso.
          var soglia = i / totale;
          var valore = gsap.utils.clamp(0.18, 1, 0.18 + (progresso - soglia) * totale * 0.9);
          parola.style.opacity = valore;
        });
      });
    }

    function onScroll() {
      if (pending) return;
      pending = true;
      requestAnimationFrame(aggiorna);
    }

    if (blocchi.length) {
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      aggiorna();
    }

    return function () {
      if (osservatore) osservatore.disconnect();
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }

  /* ---------- Filetti e blocchi che entrano ---------- */

  function reveal(scope) {
    var osservati = scope.querySelectorAll('.home__rule, [data-home-fade]');
    if (!osservati.length) return null;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          var el = entry.target;

          if (el.classList.contains('home__rule')) {
            gsap.to(el, { scaleX: 1, duration: 1.1, ease: 'power3.inOut' });
            return;
          }

          gsap.fromTo(
            el,
            { y: 32, autoAlpha: 0 },
            {
              y: 0,
              autoAlpha: 1,
              duration: 0.9,
              ease: 'power3.out',
              stagger: 0.08,
              clearProps: 'transform'
            }
          );
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.12 }
    );

    osservati.forEach(function (el) {
      observer.observe(el);
    });

    return function () {
      observer.disconnect();
    };
  }

  /* ---------- Avvio ---------- */

  function init(scope) {
    scope = scope || document;

    mm.add(
      {
        anima: '(prefers-reduced-motion: no-preference)',
        riduci: '(prefers-reduced-motion: reduce)'
      },
      function (context) {
        // Motion ridotto: niente animazioni, contenuto già completo grazie al CSS.
        if (context.conditions.riduci) return;

        apertura(scope);
        var pulisciTicker = ticker(scope);
        var pulisciManifesto = manifesto(scope);
        var pulisciReveal = reveal(scope);

        return function () {
          if (pulisciTicker) pulisciTicker();
          if (pulisciManifesto) pulisciManifesto();
          if (pulisciReveal) pulisciReveal();
        };
      }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  // Nel customizer ogni sezione ricaricata viene rianimata.
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
